import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from "react";
import { Loading } from "@/components/ui/states";

type Loader = () => Promise<{ default: ComponentType }>;

// 按 loader 缓存 lazy 组件：/login ↔ /register 互跳时 React Router 会复用同一个 LazyOutlet 实例，
// 必须跟着 load 换组件；loader 随路由表只创建一次，可直接作 key。
const cache = new WeakMap<Loader, LazyExoticComponent<ComponentType>>();

/** 包在守卫组件里的懒加载页面（登录 / 注册需要先过 GuestOnly）。 */
export function LazyOutlet({ load }: { load: Loader }) {
  let C = cache.get(load);
  if (!C) {
    C = lazy(load);
    cache.set(load, C);
  }
  return (
    <Suspense fallback={<Loading />}>
      <C />
    </Suspense>
  );
}
